import { makeStyles } from '@mui/styles';
import { ApplicationMuiTheme } from '@tassat/payments-themes/dist/types/theme';

export default makeStyles((theme: ApplicationMuiTheme) => ({
    button: {
        color: theme?.app?.applicationColors.enumColors.offWhite || '#FFFFFF',
        fontSize: '1rem',
        marginLeft: '1.5rem',
        '&:first-child': { marginLeft: 0 },
        '&:disabled': {
            backgroundColor: theme?.app?.applicationColors.enumColors.greyLight || '#C5C3C3',
            color: theme?.app?.applicationColors.enumColors.white || '#FFFFFF'
        }
    },
    buttonLabel: { padding: '0.375rem 1rem' },
    buttonIcon: {
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary || '#FFFFFF',
        borderRadius: '50%'
    },
    approvedButton: {
        backgroundColor: theme?.app?.applicationColors.successDark || '#56B4BC',
        cursor: 'inherit' as 'inherit',
        '&:hover': { backgroundColor: theme?.app?.applicationColors.successDark || '#56B4BC' }
    },
    approveButton: {
        backgroundColor: theme?.app?.applicationColors.successDark || '#56B4BC',
        '&:hover': { backgroundColor: theme?.app?.applicationColors.success || 'rgba(51, 121, 128, 0.73)' }
    },
    declinedButton: {
        backgroundColor: theme?.app?.applicationColors.failureDark || '#CE4A4A',
        cursor: 'inherit' as 'inherit',
        '&:hover': { backgroundColor: theme?.app?.applicationColors.failureDark || '#CE4A4A' }
    },
    declineButton: {
        backgroundColor: theme?.app?.applicationColors.failureDark || '#CE4A4A',
        '&:hover': { backgroundColor: theme?.app?.applicationColors.failure || 'rgba(148, 41, 41, 0.67)' }
    },
    cancelButton: {
        backgroundColor: theme?.app?.applicationColors.enumColors.greyLight || '#D8D8D8',
        border: `1px solid ${theme?.app?.applicationColors.enumColors.grey || '#979797'}`,
        borderRadius: '3px',
        color: theme?.app?.applicationColors.enumColors.black || '#000',
        '&:hover': { backgroundColor: theme?.app?.applicationColors.enumColors.grey || '#979797' }
    },
    canceledButton: {
        backgroundColor: theme?.app?.applicationColors.enumColors.greyLight || '#D8D8D8',
        border: `1px solid ${theme?.app?.applicationColors.enumColors.grey || '#979797'}`,
        borderRadius: '3px',
        cursor: 'inherit' as 'inherit',
        color: theme?.app?.applicationColors.enumColors.black || '#000',
        '&:hover': { backgroundColor: theme?.app?.applicationColors.enumColors.greyLight || '#D8D8D8' }
    }
}));